import { CSSTransition } from 'react-transition-group';
import { useMemo } from 'react';

import { useGetParams } from './hooks/useGetParams';
import { useMultiBroadcast } from './hooks/useMultiBroadcast';
import AdvtFullSize from './components/AdvtFullSize/AdvtFullSize';
import MessageGroup from './components/MessageGroup/MessageGroup';

import defaultBackground from './assets/images/bg.png';

function App() {
  const {
    bg,
    phoneNumber,
    socials,
    title,
    qrCode,
    cols,
    authorFontSize,
    msgFontSize,
  } = useGetParams();
  const { currentState, showedMessages, isVisible } = useMultiBroadcast();

  const advt_info = useMemo(
    () => ({
      qrCode: qrCode,
      label: title,
      number: phoneNumber,
      socials: socials?.split(','),
    }),
    [phoneNumber, socials, title, qrCode]
  );

  const background = useMemo(() => {
    return bg && bg !== '0'
      ? `url(${bg === '1' ? defaultBackground : bg}) center/cover no-repeat`
      : `none`;
  }, [bg]);

  return (
    <div className="app-wrapper" style={{ background }}>
      <CSSTransition
        in={isVisible}
        timeout={500}
        classNames="fade-scale"
        unmountOnExit>
        <div className="advt-wrapper">
          {advt_info && <AdvtFullSize advtInfo={advt_info} />}
        </div>
      </CSSTransition>
      <CSSTransition
        in={isVisible && currentState && currentState === 'S1'}
        timeout={500}
        classNames="fade-scale"
        unmountOnExit>
        <div className="titre-wrapper">
          <MessageGroup
            cols={cols}
            messages={showedMessages}
            authorFontSize={authorFontSize}
            msgFontSize={msgFontSize}
          />
        </div>
      </CSSTransition>
      <div id="img-loader"></div>
    </div>
  );
}

export default App;
